import { Stack } from 'tamagui'
import { FormFieldContainer } from '../form-field-container'
import { TimePickerFieldProps } from './time-picker-props'
import { useId } from 'react'

export const TimePickerField = ({
  error,
  startTime,
  value,
  required,
  labelProps,
  label,
  labelInline,
  helperText,
  hideLabel,
  isDirty,
  onChange,
  showHelperText,
  containerProps,
}: TimePickerFieldProps) => {
  const id = useId()

  const handleTimeChange = (value: string) => {
    if (!onChange) return
    onChange(value)
  }

  return (
    <FormFieldContainer
      id={id}
      error={error}
      required={required}
      labelProps={labelProps}
      label={label}
      labelInline={labelInline}
      helperText={helperText}
      showHelperText={showHelperText}
      hideLabel={hideLabel}
      isDirty={isDirty}
      {...containerProps}
    >
      <Stack bg="$white" br="$3" jc="center" h={44} px="$3.5">
        <input
          type="time"
          value={value || ''}
          onChange={(e) => handleTimeChange(e.target.value)}
          {...(startTime && { defaultValue: startTime })}
        />
      </Stack>
    </FormFieldContainer>
  )
}
